module.exports = __webpack_public_path__ + "img/alert-triangle-outline.8cf4bc06.svg";